<template>
  <div>
    <common-dialog
      ref="dialog"
      width="750px"
      show-save-button
      unit="切换分类"
      title="切换分类"
      id-key="RecordId"
      :data="data"
      form-label-width="105px"
      :save-func="api2.updateType"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家分类" prop="TypeId">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="Types"
                :value="data.TypeId"
                :clearable="true"
                :accordion="true"
                :parentSelect="false"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      data: {
        TypeId: null,
        RecordIds: null,
      },
      api: require("@/api/goods/type").default,
      api2: require("@/api/goods/info").default,
      Types: [],

      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    
    this.api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Types = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
  },
  methods: {
    getData(Ids) {
      this.data.RecordIds = Ids; //将上架列表页面传过来的选中行的id的集合赋值给本界面的RecordIds
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.TypeId = null;
      } else {
        this.data.TypeId = t.RecordId;
      }
    },
    onBeforeSave() {
      if (!this.data.TypeId) {
        this.$message.error("虚拟销量不能为空");
        return false;
      }
      return true;
  
    },
    onClosed() {},
  },
};
</script>